import {Injectable} from '@angular/core';
import {AuthConfig} from "@auth0/auth0-angular";

@Injectable({
  providedIn: 'root'
})

export class ConfigService {
  get apiControlUrl(): string {
    return (window as any).env.apiControlUrl;
  }

  get apiTicketingUrl(): string {
    return (window as any).env.apiTicketingUrl;
  }

  get externalBilletterieUrl(): string {
    return (window as any).env.externalBilletterieUrl;
  }

  get auth0ApiAudience(): string {
    return (window as any).env.auth0ApiAudience;
  }

  get auth0Config(): AuthConfig {
    return {
      domain: (window as any).env.auth0Domain,
      clientId: (window as any).env.auth0ClientId,
      authorizationParams: {
        redirect_uri: window.location.origin,
        audience: this.auth0ApiAudience,
        scope: 'openid profile email offline_access'
      },
      // Utiliser localStorage pour persister le cache entre les rechargements
      cacheLocation: 'localstorage',
      // Utiliser refresh tokens pour renouveler les tokens sans interaction utilisateur
      useRefreshTokens: true,
      // Configuration avancée pour améliorer la résilience
      useRefreshTokensFallback: false,
      httpInterceptor: {
        allowedList: [
          {
            uriMatcher: () => true
          }
        ]
      }
    }
  }
}
